import { Component, computed, inject } from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'

import { filter, map, startWith } from 'rxjs/operators'

import { OperatorDataState } from '@states/operator-data'
import { CurrentLocationIcon } from '@components/icons'
import { AsyncPipe } from '@angular/common'

@Component({
	selector: 'app-container',
	templateUrl: './container.component.html',
	styleUrl: './container.component.scss',
	imports: [AsyncPipe, RouterModule, CurrentLocationIcon],
})
export class AppContainerComponent {
	readonly #router = inject(Router)
	readonly #operatorDataState = inject(OperatorDataState)
	readonly #modules = [
		{
			path: '/',
			title: 'Validate',
		},
		{
			path: '/request-car',
			title: 'Request Car',
		},
		{
			path: '/overnight-report',
			title: 'Overnight Report',
		},
	]

	readonly moduleName$ = this.#router.events.pipe(
		filter(e => e instanceof NavigationEnd),
		startWith(this.#router.url),
		map((e: string | NavigationEnd) => {
			if (typeof e === 'string') {
				return this.#modules.find(m => m.path === e).title
			}

			return this.#modules.find(m => m.path === e.urlAfterRedirects).title
		})
	)
	readonly requestPoint = computed(
		() => this.#operatorDataState.operatorData()?.requestPoint ?? ''
	)
}
